import {Component, Input} from '@angular/core';
import {MatListItem} from "@angular/material/list";
import {RouterLink, RouterLinkActive} from "@angular/router";
import {MenuSection, MenuSectionItem} from "@app/pages/admin-panel/admin-menu.service";

@Component({
  selector: 'app-menu-section-item',
  imports: [
    MatListItem,
    RouterLinkActive,
    RouterLink
  ],
  standalone: true,
  template: `
    <mat-list-item [routerLink]="item.routerLink" [routerLinkActive]="['active']">
      <span class="sidenav-item-label">{{ item.label }}</span>
    </mat-list-item>
  `
})
export class MenuSectionItemComponent {
  @Input() item!: MenuSection | MenuSectionItem;
}
